export default __webpack_public_path__ + "static/media/logo-svnl.54273de9.png";